// Llaves maestras por rol
export const ROLE_KEYS = {
  vtic: 'VTIC-TUTOR-2026',
  aurora: 'AURORA-TUTOR-2026',
  phuma: 'PHUMA-TUTOR-2026',
  eucs: 'EUCS-TUTOR-2026',
  admin: 'ADMIN-SUPER-2026'
}

// Mapeo de etiquetas legibles
export const ROLE_LABELS = {
  vtic: 'Lucem Aspicio (VTIC)',
  aurora: 'Tutor Aurora',
  phuma: 'Tutor Phuma',
  eucs: 'Tutor EUCS',
  admin: 'Administrador de Plataforma'
}

// Validar llave de acceso y determinar rol correspondiente
export const validateAccessKey = (key) => {
  const cleanKey = key.trim()
  
  if (cleanKey === ROLE_KEYS.vtic) {
    return { success: true, role: 'vtic', label: ROLE_LABELS.vtic }
  }
  if (cleanKey === ROLE_KEYS.aurora) {
    return { success: true, role: 'aurora', label: ROLE_LABELS.aurora }
  }
  if (cleanKey === ROLE_KEYS.phuma) {
    return { success: true, role: 'phuma', label: ROLE_LABELS.phuma }
  }
  if (cleanKey === ROLE_KEYS.eucs) {
    return { success: true, role: 'eucs', label: ROLE_LABELS.eucs }
  }
  if (cleanKey === ROLE_KEYS.admin) {
    return { success: true, role: 'admin', label: ROLE_LABELS.admin }
  }
  
  return { success: false, error: 'Llave de acceso inválida' }
}

